import $ from "jquery";
import moment from "moment";
import { u_ } from "@pressmedia/webappbase";

function addEventList($day, list, currentDate) {
	if( !($day instanceof $) || !$day.length ) {
		throw new TypeError("arguments[0] must be instance of jQuery.");
	}
	if(!Array.isArray(list) || !list.length) {
		throw new TypeError("arguments[1] must be array.");
	}
	if( !moment.isMoment(currentDate) || !currentDate.isValid() ) {
		throw new TypeError("arguments[3] must be instance of Moment.");
	}
	
	$.fn.append.apply(
		$("<ul/>").addClass(`${this.classPrefix}events`).attr({
			"data-events": list.length
		}),
		list.map(data => {
			if( u_.isObject(data) ) {
				if(data.start) {
					if( currentDate.isSame(data.start, "day") ) {
						$day.addClass(`${this.classPrefix}event-start-day`);
					}
					
					if( data.end && currentDate.isSame(data.end, "day") ) {
						$day.addClass(`${this.classPrefix}event-end-day`);
					}
				}
				
				data.$elm = $("<a/>").addClass(
					`${this.classPrefix}event-item`
				).data("item", data).attr({
					"href": "./",
					"data-name": data.name || ""
				});
				
				return $("<li/>").addClass(
					`${this.classPrefix}event-box`
				).append(data.$elm);
			}
		})
	).appendTo($day);
	
	return this;
}

export default addEventList;
